import { Configuration } from "msal";

declare var WebConfigData: any;

export class MsalConfigApp {
  static loadConfig(): Configuration {
    return {
      auth: {
        clientId: WebConfigData.ClientIdSSO,
        authority: WebConfigData.AuthoritySSO,
        redirectUri: WebConfigData.RedirectUriSSO
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
      }
    };
  }
}
  